import axios from '../libs/axios'

const baseURL = "/api/dataset";
// const imageURL = "/api/image";


export default {
  allData(params) {
    return axios.get(`${baseURL}/data`, {
      params: {
        ...params
      }
    });
  },
  getData(id, params) {
    return axios.get(`${baseURL}/${id}/data`, {
      params: {
        ...params
      }
    });
  },
  saveSettings(id, params) {
    return axios.post(`${baseURL}/${id}`, {
      settings: {
        ...params
      }
    });
  },
  create(name, categories) {
    return axios.post(`${baseURL}/?name=${name}`, {
      categories: categories
    });
  },
  create_for_user(name, categories, owner) {
    return axios.post(`${baseURL}/?name=${name}`, {
      categories: categories,
      owner: owner
    });
  },
  generate(id, body) {
    return axios.post(`${baseURL}/${id}/generate`, {
      ...body
    });
  },
  // exportingCOCO(id, categories) {
  //   return axios.get(`${baseURL}/${id}/export?categories=${categories}`);
  // },
  // getCoco(id) {
  //   return axios.get(`${baseURL}/${id}/coco`);
  // // },
  // uploadCoco(id, file) {
  //   let form = new FormData();
  //   form.append("coco", file);

  //   return axios.post(`${baseURL}/${id}/coco`, form, {  
  //     headers: {
  //       "Content-Type": "multipart/form-data"
  //     }
  //   });
  // },
  uploadImg(id, file) {
    let form = new FormData();
    form.append("image", file);
    return axios.post(`/api/image/?dataset_id=${id}`, form, {
      headers: {
        "Content-Type": "multipart/form-data"
      }, timeout: 120000
    });
  },
  uploadImgs(id, files) {
    const form = new FormData();
    for (let i = 0; i < files.length; i++) {
      form.append("image", files[i]);
    }
    return axios.post(`/api/image/multiple/?dataset_id=${id}`, form, {
      headers:{
        "Content-Type": "multipart/form-data"
      },
      timeout: 120000,
    });
  },
  uploadJpeg(datasetId, file, patientInfo) {
    var form = new FormData();
    form.append("image", file);
    form.append("dataset_id", datasetId);
    form.append("patient_name", patientInfo.name);
    form.append("patient_age", patientInfo.age);
    form.append("patient_sex", patientInfo.sex);
    if (patientInfo.studyDate) {
      form.append("study_date", patientInfo.studyDate);
    }
    if (patientInfo.patientId) {
      form.append("patient_id", patientInfo.patientId);
    }
    return axios.post("/api/image/jpeg/", form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000
    });
  },
  export(id, format) {
    return axios.get(`${baseURL}/${id}/${format}`);
  },
  getUsers(id) {
    return axios.get(`${baseURL}/${id}/users`);
  },
  getStats(id) {
    return axios.get(`${baseURL}/${id}/stats`);
  },
  getExports(id) {
    return axios.get(`${baseURL}/${id}/exports`);
  },
  resetMetadata(id) {
    return axios.get(`${baseURL}/${id}/reset/metadata`);
  },
  // Check which image IDs exist in DB (Worker processing completed)
  checkImageIds(ids) {
    return axios.post('/api/image/check-ids', { ids: ids });
  }
};
